import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { delayolwo40i9ucjz as delay } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function afterTimeout(_this__u8e3s4, milliseconds, action) {
  // Inline function 'kotlin.let' call
  var it = launch(_this__u8e3s4, VOID, VOID, afterTimeout$slambda_0(milliseconds, action));
  return () => {
    it.ma3();
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = delay($this.ccv_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.dcv_1();
  return Unit_instance;
}
var afterTimeout$slambdaClass;
function afterTimeout$slambda() {
  if (afterTimeout$slambdaClass === VOID) {
    class $ {
      constructor($milliseconds, $action) {
        this.ccv_1 = $milliseconds;
        this.dcv_1 = $action;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    afterTimeout$slambdaClass = $;
  }
  return afterTimeout$slambdaClass;
}
function afterTimeout$slambda_0($milliseconds, $action) {
  var i = new (afterTimeout$slambda())($milliseconds, $action);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  afterTimeout as afterTimeout2ddqxaabn39mu,
};
//endregion

//# sourceMappingURL=afterTimeout.mjs.map
